import { useMutation } from "@tanstack/react-query";

import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { postBinaryResponse } from "~/shared/services/api/fetch-client.ts";
import type { ApiResult } from "~/shared/types/api-types.ts";

import type { BulkTenderDocumentsRequest } from "../schemas/bulk-tender-document-schema.ts";
import { bulkTenderDocumentsRequestSchema } from "../schemas/bulk-tender-document-schema.ts";

const INVALID_DOCUMENT_REQUEST_MESSAGE =
	"Select at least one successfully tendered shipment before generating documents.";

export const useBulkTenderDocuments = () => {
	return useMutation<ApiResult<ArrayBuffer>, Error, BulkTenderDocumentsRequest>(
		{
			mutationFn: async (request) => {
				const parsedRequest =
					bulkTenderDocumentsRequestSchema.safeParse(request);
				if (!parsedRequest.success) {
					return {
						success: false,
						error: INVALID_DOCUMENT_REQUEST_MESSAGE,
						details: parsedRequest.error,
					} as const;
				}

				return await postBinaryResponse(
					apiRoutes.BULKTENDERDOCUMENTS,
					parsedRequest.data,
				);
			},
		},
	);
};
